export default "__VITE_ASSET__DiEDUUGy__"